export const DEMO_CAL_LINK = 'lucianclapa/demo-achizitii-publice';
export const DEMO_EVENT_ID = 6979504;
export const DEMO_CAL_URL = 'https://cal.com/' + DEMO_CAL_LINK;
let instance = 0;

// Official Cal.com queued embed API; loaded only when the visitor opens the calendar.
function installCal(win) {
    if (win.Cal) return;
    const cal = function () {
        const args = arguments;
        if (args[0] === 'init') {
            const namespace = args[1];
            const api = function () { api.q.push(arguments); };
            api.q = [];
            cal.ns[namespace] = cal.ns[namespace] || api;
            cal.ns[namespace].q.push(args);
            cal.q.push(['initNamespace', namespace]);
        } else {
            cal.q.push(args);
        }
    };
    cal.q = [];
    cal.ns = {};
    cal.loaded = true;
    win.Cal = cal;
    const script = win.document.createElement('script');
    script.src = 'https://app.cal.com/embed/embed.js';
    script.async = true;
    win.document.head.appendChild(script);
}

export function mountDemoCalendar(element, { attribution = {}, onReady, onError, onRequest }, win = window) {
    installCal(win);
    const namespace = 'publicDemo' + (++instance);
    let active = true;
    const timeout = win.setTimeout(() => { if (active) onError(); }, 20000);
    const ready = () => {
        if (!active) return;
        win.clearTimeout(timeout);
        onReady();
    };
    win.Cal('init', namespace, { origin: 'https://cal.com' });
    const api = win.Cal.ns[namespace];
    api('on', { action: 'linkReady', callback: ready });
    api('on', { action: 'linkFailed', callback: () => { if (active) { win.clearTimeout(timeout); onError(); } } });
    api('on', {
        action: 'bookingSuccessfulV2',
        callback: event => {
            const data = event && event.detail && event.detail.data;
            if (active && data && data.eventTypeId === DEMO_EVENT_ID && typeof data.uid === 'string' && data.uid) {
                // A booking may still require approval; this is never a qualified lead or confirmed demo.
                onRequest(data.uid);
            }
        },
    });
    api('inline', {
        elementOrSelector: element,
        calLink: DEMO_CAL_LINK,
        config: { layout: 'month_view', theme: 'light', ...attribution },
    });
    api('ui', { theme: 'light', layout: 'month_view', hideEventTypeDetails: false });
    return () => {
        active = false;
        win.clearTimeout(timeout);
        element.replaceChildren();
    };
}
